var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTubeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.25C6.58579 1.25 6.25 1.58579 6.25 2C6.25 2.41421 6.58579 2.75 7 2.75H8V11.9696C9.47001 11.5601 11.0563 11.8328 12.3108 12.7289C13.1631 13.3377 14.2395 13.542 15.2556 13.288L16 13.1019V2.75H17C17.4142 2.75 17.75 2.41421 17.75 2C17.75 1.58579 17.4142 1.25 17 1.25H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6194 14.7432L16 14.6481V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V13.551L8.106 13.5113C9.22065 13.0933 10.4702 13.2576 11.4389 13.9495C12.6489 14.8137 14.1769 15.1039 15.6194 14.7432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTubeAlt);
export default __webpack_public_path__ + "static/media/test-tube-alt.d2e76cd33cc51d798b657a70c4bbb853.svg";
export { ForwardRef as ReactComponent };